import { render, staticRenderFns } from "./tour-edit.vue?vue&type=template&id=67c0d9f1&scoped=true&"
import script from "./tour-edit.vue?vue&type=script&lang=js&"
export * from "./tour-edit.vue?vue&type=script&lang=js&"
import style0 from "./tour-edit.vue?vue&type=style&index=0&id=67c0d9f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0d9f1",
  null
  
)

export default component.exports